import { all } from 'redux-saga/effects';

import {
  watchCallLogAmplitudeEvent,
  watchSetAmplitudeUserId
} from './amplitude';
import {
  watchActiveCategorySet,
  watchCreateEvent,
  watchDeleteActiveEvent,
  watchFetchEvent,
  watchFetchEvents,
  watchUpdateActiveEvent,
} from './events';
import { watchSignIn, watchSignOut, watchSignUp } from './auth';

const rootSaga = function* rootSaga() {
  yield all([
    watchActiveCategorySet(),
    watchCallLogAmplitudeEvent(),
    watchCreateEvent(),
    watchDeleteActiveEvent(),
    watchFetchEvent(),
    watchFetchEvents(),
    watchSetAmplitudeUserId(),
    watchSignIn(),
    watchSignOut(),
    watchSignUp(),
    watchUpdateActiveEvent(),
  ]);
};

export default rootSaga;



// WEBPACK FOOTER //
// ./src/redux/sagas/index.js